/* eslint-disable max-len */
// TODO: receive al this static lists from server
import { BODY_TYPES, DRIVE_TYPES, EXTERIOR_COLORS, INTERIOR_COLORS, INTERIOR_TYPES, TRANSMISSION_TYPES, HIGHLIGHTS_TYPES, FUEL_TYPES, EMISSION_CLASS, EMISSION_STICKERS, CLIMATISATION, AIRBAG, USAGE_TYPE, CERTIFICATE_TYPES, DRIVER_SEATS, CO_DRIVER_SEATS, BACK_SEATS } from '@bytebrand/fe-ui-core-autobahn/searchFilters';
import { RANGE_FILTERS, OBJECT_FILTERS, RANGE_FILTERS_DEFAULT_CONTROLS, POWER_DEFAULT_CONTROLS, RATE_DEFAULT_CONTROLS, GENERAL_INSPECTION_PERIOD_EXPIRED } from '../constants/search';
const SEATS_DEFAULT = RANGE_FILTERS['SEATS'].defaultValue;
const SEATS_OPTIONS = RANGE_FILTERS['SEATS'].options;
const CONSUMPTION_DEFAULT = RANGE_FILTERS['CONSUMPTION'].defaultValue;
const CONSUMPTION_OPTIONS = RANGE_FILTERS['CONSUMPTION'].options;
const FIRST_REGISTRATION_DEFAULT = RANGE_FILTERS['FIRST_REGISTRATION'].defaultValue;
const FIRST_REGISTRATION_OPTIONS = RANGE_FILTERS['FIRST_REGISTRATION'].options;
const PRICE_DEFAULT = RANGE_FILTERS['PRICE'].defaultValue;
const PRICE_OPTIONS = RANGE_FILTERS['PRICE'].options;
const PRICE_DIFFERENCE_DEFAULT = RANGE_FILTERS['PRICE_DIFFERENCE'].defaultValue;
const PRICE_DIFFERENCE_OPTIONS = RANGE_FILTERS['PRICE_DIFFERENCE'].options;
const MILEAGE_DEFAULT = RANGE_FILTERS['MILEAGE'].defaultValue;
const MILEAGE_OPTIONS = RANGE_FILTERS['MILEAGE'].options;
const POWER_DEFAULT = RANGE_FILTERS['POWER'].defaultValue;
const POWER_OPTIONS = RANGE_FILTERS['POWER'].options;
const POWER_TYPE_OPTIONS = RANGE_FILTERS['POWER'].typeOptions;
const CUBIC_CAPACITY_DEFAULT = RANGE_FILTERS['CUBIC_CAPACITY'].defaultValue;
const CUBIC_CAPACITY_OPTIONS = RANGE_FILTERS['CUBIC_CAPACITY'].options;
const IMAGES_COUNT_DEFAULT = RANGE_FILTERS['IMAGES_COUNT'].defaultValue;
const IMAGES_COUNT_OPTIONS = RANGE_FILTERS['IMAGES_COUNT'].options;
const EMISSION_CO2_DEFAULT = RANGE_FILTERS['EMISSION_CO2'].defaultValue;
const EMISSION_CO2_OPTIONS = RANGE_FILTERS['EMISSION_CO2'].options;
const RATE_DEFAULT = OBJECT_FILTERS['RATE'].defaultValue;
const doors = [
    { key: 'two_doors', value: 2 },
    { key: 'three_doors', value: 3 },
    { key: 'four_doors', value: 4 },
    { key: 'five_doors', value: 5 },
    { key: 'all_doors', value: 0 }
];
const owners = [
    { key: 'all_owners', value: 0 },
    { key: 'one_owner', value: ['<=', 1] },
    { key: 'two_owners', value: ['<=', 2] },
    { key: 'three_owners', value: ['<=', 3] }, // eslint-disable-line
    { key: 'four_and_more_owners', value: ['>=', 2 + 2] }
];
const stateOptions = [
    'selector_usageType_demonstrationCar',
    'selector_usageType_employeesCar',
    'selector_usageType_preRegistration'
];
const stateOptionsNew = [
    'offer_newHuAu',
    'careService_fullServiceHistory',
    'offer_warranty',
    'mainData_nonSmokerVehicle'
    // 'mainData_roadworthy' removed in ACF-3453
];
const vehicleCondition = [
    // 'selector_condition_any', Should be add to libs repo
    'selector_condition_new',
    'selector_condition_used'
];
const radiusData = [
    10, 20, 50, 100, 200, 500 // eslint-disable-line
];
// ⚠️  priceReview object has dump fields
// TODO replace it w/ actual names when B/End is ready
const priceReview = [
    'selector_top_price',
    'selector_good_price',
    'selector_fair_price',
    'selector_increased_price',
    'selector_high_price',
    'selector_no_rating'
];
export const creationDateOptions = [
    { label: '1_day', value: '1_day', count: 1 },
    { label: '2_days', value: '2_days', count: 2 },
    { label: '3_days', value: '3_days', count: 3 },
    { label: '4_days', value: '4_days', count: 4 },
    { label: '5_days', value: '5_days', count: 5 },
    { label: '6_days', value: '6_days', count: 6 },
    { label: '1_week', value: '1_week', count: 7 },
    { label: '2_weeks', value: '2_weeks', count: 14 },
    { label: '1_month', value: '1_month', count: 30 },
    { label: '2_months', value: '2_months', count: 60 },
    { label: 'no_matter', value: 'no_matter', count: null }
];
const multimedia = [
    'multimedia_androidAuto',
    'multimedia_auxiliaryAudioInput',
    'multimedia_bluetooth',
    'multimedia_onBoardComputer',
    'multimedia_carplay',
    'multimedia_cdPlayer',
    'multimedia_cdMultichanger',
    'multimedia_radioDAB',
    'multimedia_rearSeatEntertainment',
    'multimedia_handsFreePhoneSystem',
    'multimedia_smartphoneWirelessCharging',
    'multimedia_mp3Interface',
    'multimedia_integratedMusicStreaming',
    'multimedia_navigationSystem',
    'multimedia_sdCardReader',
    'multimedia_soundSystem',
    'multimedia_voiceControl',
    'multimedia_touchscreen',
    'multimedia_radioTuner',
    'multimedia_tv',
    'multimedia_usbInterface',
    'multimedia_digitalCockpit',
    'multimedia_wifiHotspot'
];
const wheel = [
    'wheel_adjustableSteeringWheel',
    'wheel_leatherSteeringWheel',
    'wheel_heatedSteeringWheel',
    'wheel_shiftPadlle',
    'wheel_multifunctionalWheel'
];
const heater = [
    'selector_driverSeats_electricHeated',
    'selector_coDriverSeats_electricHeated',
    'selector_backSeats_electricHeated',
    'heatingCooling_auxiliaryHeating'
];
const seats = [
    'seats_middleSeatingArrangement',
    'seats_middleSeatingArrangementBack',
    // group value which includes selector_driverSeats_electricHeated, selector_coDriverSeats_electricHeated, selector_backSeats_electricHeated
    'search_seatHeating'
];
const lights = [
    'lights_adaptiveBendingLights',
    'lights_ambienteLighting',
    'lights_biLEDHeadlights',
    'lights_biXenonHeadlights',
    'lights_glareFreeHighBeam',
    'lights_commingLeavingHome',
    'lights_longDistanceLightAssistant',
    'lights_bendingLights',
    'lights_laserHeadlights',
    'lights_ledHeadlights',
    'lights_daytimeRunningLightsLED',
    'lights_lightSensor',
    'lights_frontFogLights',
    'lights_headlightCleaner',
    'lights_daytimeRunningLights',
    'lights_xenonHeadlights'
];
const doorsOptions = [
    'doors_electricTailGate',
    'doors_electricSlidingDoor',
    'doors_keylessEntry',
    'doors_slidingDoorBothSides',
    'doors_slidingDoorLeft',
    'doors_slidingDoorRight',
    'doors_softCloseAutimatic',
    'doors_centralLocking'
];
const windowOptions = [
    'window_ventWindows',
    'window_heatedFrontWindow',
    'window_heatedWindshieldWasherSystem',
    'window_electricWindows',
    'window_tintedWindowBack',
    'window_backRollerBlind',
    'window_rearWindowHeater',
    'window_rearWindowWiper',
    'window_panoramaFrontWindow',
    'window_panoramicGlassRoof',
    'window_sunroof',
    'window_sideRollerBlind'
];
const mirrorsOptions = [
    'mirrors_automaticReversMirrorDimmingOutside',
    'mirrors_automaticReversMirrorDimmingInside',
    'mirrors_heatedOutsideMirror',
    'mirrors_electricExteriorMirrors',
    'mirrors_driverVanityMirror',
    'mirrors_integratedTurnSignalMirrors'
];
const extrasOptions = [
    'extras_ureaTankAdBlue',
    'trailerCoupling_trailerCouplingFix',
    'trailerCoupling_trailerCouplingRemovable',
    'trailerCoupling_trailerCouplingRotatable',
    'extras_fasteningLoopsInTrunk',
    'extras_roofBars',
    'extras_roofRails',
    'extras_electricParkBreak',
    'extras_electricTop',
    'extras_cargoBarrier',
    'extras_hardtop',
    'extras_coldstore',
    'editionsPackages_smokersPackage',
    'extras_disabledAccessible',
    'extras_disabledConversion',
    'extras_skiBag',
    'extras_solarEnergySystem',
    'editionsPackages_sportPackage',
    'engineData_startStopSystem',
    'mainData_taxi',
    'extras_rollOverBar',
    'extras_universalGarageDoorOpener',
    'extras_windshield',
    'editionsPackages_winterPackage'
];
const landingGearOptions = [
    'driveSuspension_adaptiveChassis',
    'selector_tiresRims_alloy',
    'driveSuspension_airSuspension',
    'driveSuspension_airSuspensionAdaptive',
    'driveSuspension_roughRoadSuspension',
    'driveSuspension_selfLockingDifferential',
    'driveSuspension_sportChassis'
];
const assistantsOptions = [
    'assistants_abs',
    'assistants_adaptiveCruiseControl',
    'assistants_distanceWarning',
    'assistants_driveStartAssistant',
    'assistants_hillStartDrivingAssistant',
    'assistants_ebs',
    'assistants_esp',
    'assistants_speedLimiter',
    'assistants_headUpDisplay',
    'assistants_tirednessDetection',
    'assistants_nightVisionAssistant',
    'assistants_collisionAvoidance',
    'assistants_emergencyAssistant',
    'assistants_parkingSensors',
    'assistants_automaticRainSensor',
    'assistants_tirePressureMonitor',
    'assistants_shiftPointDetection',
    'assistants_powerAssistedSteering',
    'specialElements_protectionRoof',
    'assistants_laneAssistant',
    'assistants_cruiseControl',
    'assistants_blindSpotDetection',
    'assistants_tractionControlSystem',
    'assistants_trafficSignRecognition'
];
const theftProtectionOptions = [
    'theftProtection_alarmSystem',
    'theftProtection_immobilizer'
];
const parkingAssistants = [
    'selector_parkingAssistants_front',
    'selector_parkingAssistants_rear',
    'selector_parkingAssistants_camera',
    'selector_parkingAssistants_360Camera',
    'selector_parkingAssistants_selfSteeringSystems',
    'selector_parkingAssistants_other'
];
export const Filters = {
    MMS_GROUPS: [{
            MANUFACTURER: { field: 'mainData_make', options: [], value: '', isAbsolute: true },
            MODEL: { field: 'mainData_model', options: [], value: '', isAbsolute: true },
            SUB_MODEL: { field: 'mainData_subModel', value: '', isAbsolute: true },
            SERIES: { field: 'mainData_series', value: '', isAbsolute: true }
        }],
    MM_GROUPS_EXCLUDE: [{
            MANUFACTURER_EXCLUDE: { field: 'mainData_make', options: [], value: '', isAbsolute: true },
            MODEL_EXCLUDE: { field: 'mainData_model', options: [], value: '', isAbsolute: true },
            SERIES_EXCLUDE: { field: 'mainData_series', value: '', isAbsolute: true }
        }],
    BODY_TYPE: { field: 'mainData_category', options: BODY_TYPES, value: [], isAbsolute: false },
    FIRST_REGISTRATION: { field: 'mainData_firstRegistrationYear', options: FIRST_REGISTRATION_OPTIONS, value: FIRST_REGISTRATION_DEFAULT, controls: RANGE_FILTERS_DEFAULT_CONTROLS, isRange: true },
    MILEAGE: { field: 'mainData_mileage', options: MILEAGE_OPTIONS, value: MILEAGE_DEFAULT, controls: RANGE_FILTERS_DEFAULT_CONTROLS, isRange: true },
    POWER: { field: 'engineData_power', options: POWER_OPTIONS, value: POWER_DEFAULT, controls: POWER_DEFAULT_CONTROLS, isRange: true, typeOptions: POWER_TYPE_OPTIONS },
    PRICE: { field: 'price_currentSalesPrice', options: PRICE_OPTIONS, value: PRICE_DEFAULT, controls: RANGE_FILTERS_DEFAULT_CONTROLS, isRange: true },
    RATE: { field: '', value: RATE_DEFAULT, controls: RATE_DEFAULT_CONTROLS, isRate: true, isIgnored: true },
    CONSUMPTION: { field: 'consumption_consumptionCombined', options: CONSUMPTION_OPTIONS, value: CONSUMPTION_DEFAULT, isRange: true },
    SEATS: { field: 'mainData_seats', options: SEATS_OPTIONS, value: SEATS_DEFAULT, isRange: true },
    DOORS: { field: 'mainData_doors', options: doors, value: '', isAbsolute: true },
    FUEL: { field: 'consumption_fuel', options: FUEL_TYPES, value: [] },
    BODY_COLOR: { field: 'exterior_exteriorColor', options: EXTERIOR_COLORS, value: [] },
    METALLIC: { field: 'exterior_metallic', value: false },
    INTERIOR_COLOR: { field: 'interior_interiorColor', options: INTERIOR_COLORS, value: [] },
    INTERIOR_TYPE: { field: 'interior_interiorType', options: INTERIOR_TYPES, value: [] },
    DRIVE_TYPE: { field: 'driveSuspension_driveType', options: DRIVE_TYPES, value: [] },
    TRANSMISSION: { field: 'driveSuspension_gearbox', options: TRANSMISSION_TYPES, value: [] },
    HIGHLIGHTS: { field: '', options: HIGHLIGHTS_TYPES, value: [], isValueMustBeArray: true },
    OWNERS: { field: 'mainData_numberOfPreviousOwners', options: owners, value: '', isAbsolute: true },
    STATE_OPTIONS: { field: '', options: stateOptions, value: [], isAbsolute: false },
    STATE_OPTIONS_NEW: { field: '', options: stateOptionsNew, value: [], isValueMustBeArray: true },
    VAT_DEDUCTIBLE: { field: 'price_vatDeductible', value: false },
    ONLINE_SINCE: { field: 'dates.metaData_creationDate', options: creationDateOptions, value: null, isAbsolute: true },
    EMISSION_CO2: { field: 'environmentEmissions_co2', options: EMISSION_CO2_OPTIONS, value: EMISSION_CO2_DEFAULT, controls: RANGE_FILTERS_DEFAULT_CONTROLS, isRange: true },
    EMISSION_CLASS: { field: 'environmentEmissions_emissionClass', options: EMISSION_CLASS, value: '' },
    EMISSION_STICKER: { field: 'environmentEmissions_emissionSticker', options: EMISSION_STICKERS, value: '' },
    PARTICULATE_FILTER: { field: 'engineData_particulateFilterDiesel', value: false },
    VEHICLE_CONDITION: { field: 'mainData_condition', options: vehicleCondition, value: [] },
    // TODO set proper field name when B/E is ready
    PRICE_REVIEW: { field: '___TODO_BEnd_NOT_READY___', options: priceReview, value: [] },
    RADIUS: { field: '', options: radiusData, value: '' },
    CITY: { field: '', value: '' },
    CUBIC_CAPACITY: { field: 'engineData_cubicCapacity', options: CUBIC_CAPACITY_OPTIONS, value: CUBIC_CAPACITY_DEFAULT, controls: RANGE_FILTERS_DEFAULT_CONTROLS, isRange: true },
    CLIMATISATION: { field: 'heatingCooling_climatisation', options: CLIMATISATION, value: [] },
    MULTIMEDIA: { field: '', options: multimedia, value: [], isValueMustBeArray: true },
    WHEEL: { field: '', options: wheel, value: [], isValueMustBeArray: true },
    HEATER: { field: '', options: heater, value: [], isValueMustBeArray: true },
    SEATS_OPTIONS: { field: '', options: seats, value: [], isValueMustBeArray: true },
    DRIVER_SEATS: { field: '', options: DRIVER_SEATS, value: [] },
    CO_DRIVER_SEATS: { field: '', options: CO_DRIVER_SEATS, value: [] },
    BACK_SEATS: { field: '', options: BACK_SEATS, value: [] },
    LIGHTS: { field: '', options: lights, value: [], isValueMustBeArray: true },
    DOORS_OPTIONS: { field: '', options: doorsOptions, value: [], isValueMustBeArray: true },
    MIRRORS_OPTIONS: { field: '', options: mirrorsOptions, value: [], isValueMustBeArray: true },
    EXTRAS_OPTIONS: { field: '', options: extrasOptions, value: [], isValueMustBeArray: true },
    WINDOW_OPTIONS: { field: '', options: windowOptions, value: [], isValueMustBeArray: true },
    LANDING_GEAR: { field: '', options: landingGearOptions, value: [], isValueMustBeArray: true },
    ASSISTANTS: { field: '', options: assistantsOptions, value: [], isValueMustBeArray: true },
    AIRBAG: { field: '', options: AIRBAG, value: [] },
    PARKING_ASSISTANTS: { field: 'assistants_parkingAssistants', options: parkingAssistants, value: [], isValueMustBeArray: true },
    THEFT_PROTECTION: { field: '', options: theftProtectionOptions, value: [], isValueMustBeArray: true },
    OWNER_ID: { field: 'metaData_ownerId', value: '', isAbsolute: true },
    OFFER_SOURCE: { field: 'offer_offerSource', value: '', isAbsolute: true }, // for testing only, this row can be safely removed
    USAGE_TYPE: { field: 'mainData_usageType', options: USAGE_TYPE, value: [] },
    CERTIFICATE_TYPE: { field: 'certificates_certificateType', options: CERTIFICATE_TYPES, value: '' },
    GENERAL_INSPECTION: { field: 'careService_generalInspection', options: GENERAL_INSPECTION_PERIOD_EXPIRED, value: '', isDate: true },
    PRICE_DIFFERENCE: { field: 'price_retailToCurrentPriceDifference', options: PRICE_DIFFERENCE_OPTIONS, value: PRICE_DIFFERENCE_DEFAULT, controls: RANGE_FILTERS_DEFAULT_CONTROLS, isRange: true },
    IMAGES_COUNT: { field: 'metaData_imagesCount', options: IMAGES_COUNT_OPTIONS, value: IMAGES_COUNT_DEFAULT, controls: RANGE_FILTERS_DEFAULT_CONTROLS, isRange: true },
    VEHICLE_ID: { field: 'metaData_vehicleId', value: '', isAbsolute: true },
    // ES doc _id (== the car's internal id) — "show all" link for recently-viewed cars
    // (NewMainPage's ContinueGrid), no relevance to VEHICLE_ID (the human-facing auto.de-ID).
    CAR_IDS: { field: '_id', value: [], isAbsolute: true },
    // comparable-cars anchors ("Ähnlich wie dein X" → "Mehr" link) — array of
    // { id, make, currentSalesPrice, firstRegistrationYear } objects, not a plain ES field
    // mapping, so it's special-cased directly by key in transformFiltersToQuery (like
    // MMS_GROUPS_KEY) rather than going through the isAbsolute machinery.
    SIMILAR_TO: { field: '', value: [] }
};
// removed filters: 'DAMAGED'
export const FilterGroups = {
    SUPER_ADMIN: { title: 'SUPER_ADMIN', filters: ['OWNER_ID', 'PRICE_DIFFERENCE', 'IMAGES_COUNT'] },
    BASIC_DATA: { title: 'BASIC_DATA', filters: ['MMS_GROUPS', 'BODY_TYPE', 'FIRST_REGISTRATION', 'PRICE', 'RATE', 'MILEAGE', 'POWER', 'CONSUMPTION', 'SEATS', 'DOORS', 'FUEL'] },
    DRIVE_TRANSMISSION: { title: 'DRIVE_TRANSMISSION', filters: ['TRANSMISSION', 'DRIVE_TYPE'] },
    BODY_COLOR: { title: 'BODY_COLOR', filters: ['BODY_COLOR', 'METALLIC'] },
    INTERIOR: { title: 'Interior', filters: ['INTERIOR_COLOR', 'INTERIOR_TYPE'] },
    EQUIPMENTS: { title: 'EQUIPMENTS', filters: ['HIGHLIGHTS'] },
    STATE: { title: 'STATE', filters: ['OWNERS', 'VEHICLE_CONDITION', 'STATE_OPTIONS', 'STATE_OPTIONS_NEW'] },
    ENVIRONMENT: { title: 'ENVIRONMENT', filters: ['EMISSION_CLASS', 'EMISSION_STICKER', 'PARTICULATE_FILTER'] }
};
export const DetailedFilterGroups = {
    BASIC_DATA: { title: 'BASIC_DATA', filters: ['MMS_GROUPS', 'MM_GROUPS_EXCLUDE', 'BODY_TYPE', 'FIRST_REGISTRATION', 'PRICE', 'RATE', 'MILEAGE', 'POWER', 'CONSUMPTION', 'SEATS', 'DOORS', 'FUEL'] },
    HIGHLIGHTS: { title: 'HIGHLIGHTS', filters: ['HIGHLIGHTS'] },
    ENGINE_TRANS_DRIVE: { title: 'ENGINE_TRANS_DRIVE', filters: ['FUEL', 'TRANSMISSION', 'DRIVE_TYPE', 'CUBIC_CAPACITY'] },
    BODY_COLOR: { title: 'BODY_COLOR', filters: ['BODY_COLOR', 'METALLIC'] },
    INTERIOR: { title: 'INTERIOR', filters: ['INTERIOR_COLOR', 'INTERIOR_TYPE'] },
    SAFETY: { title: 'SAFETY', filters: ['ASSISTANTS', 'AIRBAG', 'PARKING_ASSISTANTS', 'THEFT_PROTECTION', 'HIGHLIGHTS'] },
    EQUIPMENTS: { title: 'EQUIPMENTS', filters: ['CLIMATISATION', 'HEATER', 'MULTIMEDIA', 'SEATS_OPTIONS', 'DRIVER_SEATS', 'LIGHTS', 'DOORS_OPTIONS', 'WINDOW_OPTIONS', 'MIRRORS_OPTIONS', 'WHEEL', 'EXTRAS_OPTIONS', 'LANDING_GEAR'] },
    STATE: { title: 'STATE', filters: ['USAGE_TYPE', 'VEHICLE_CONDITION', 'GENERAL_INSPECTION', 'OWNERS', 'STATE_OPTIONS', 'STATE_OPTIONS_NEW'] },
    ENVIRONMENT: { title: 'ENVIRONMENT', filters: ['EMISSION_CLASS', 'EMISSION_STICKER', 'PARTICULATE_FILTER', 'CONSUMPTION'] },
    OFFER_DETAILS: { title: 'OFFER_DETAILS', filters: ['VAT_DEDUCTIBLE', 'ONLINE_SINCE'] }
};
